import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	panelSplitter: {
		id: 'platform-conversation-assistant.panelSplitter.label',
		defaultMessage: 'Resize panel',
		description: 'label text for a button that will allow resizing of the right side panel',
	},
});
